<div class="h-full p-4 flex flex-col max-w-[500px]">

  <!-- Title  -->
  <div class="flex flex-col text-center">
    <span class="main-title-font text-xl">{{'alertAlcoComponent.welcome'|translate}} </span>
  </div>

  <!-- Textes  -->
  <div class="flex-1 flex flex-col scrolled mt-4 mb-4">

    <div class="text-center text-sm">

      <div>
        <span class=""> {{'alertAlcoComponent.age'|translate}} </span>
      </div>

      <div>
        <span class=""> {{'alertAlcoComponent.mod'|translate}} </span>
      </div>

      <div>
        <span class=""> {{'alertAlcoComponent.pregnate'|translate}} </span>
      </div>
      <div>
        <span class=""> {{'alertAlcoComponent.tabac'|translate}}  </span>
      </div>

    </div>

  </div>

  <!-- Buttons  -->
  <div class="flex flex-col items-center w-full gap-2">

    <button class="w-full" (click)="closeDial(true)" angulartics2On="click"
            [ngClass]="cssService.defaultPositiveDialogButton"
      angularticsAction="closeAlertAlcoolDial" angularticsCategory="order">{{'button.validate'| translate}}</button>

    <button class="w-full"
      [ngClass]="cssService.defaultNegativeDialogButton"
      (click)="closeDial(false)">{{"dialogs.go-back" | translate}}</button>

  </div>

</div>
